import { storage } from '../lib/storage';
import { Product, AffiliateClick, User } from '../types';

/**
 * AffiliateService: Lynqar ke 'External Engine' ka core logic.
 * Ye handle karta hai clicks track karna aur redirection logic.
 */
export const affiliateService = {
  /**
   * Jab user affiliate product (partner product) par click karta hai:
   * 1. Click event generate hota hai.
   * 2. Local storage/DB me save hota hai analytics ke liye.
   * 3. Tracking parameters inject hote hain (e.g., utm_source=lynqar).
   * 4. Naye tab me partner URL open hota hai.
   */
  trackClick: (product: Product, user: User | null) => {
    // 1. Click data prepare karo (Analytics ke liye)
    const click: AffiliateClick = {
      id: `clk-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
      productId: product.id,
      storeId: product.storeId,
      timestamp: new Date().toISOString(),
      userId: user?.id
    };

    // 2. Click ko save karo taaki merchant dashboard me analytics dikh sake
    storage.saveAffiliateClick(click);
    
    // 3. URL Processing (Automatic Tracking ID injection)
    let finalUrl = product.externalUrl || '';
    
    if (finalUrl) {
      try {
        const urlObj = new URL(finalUrl);
        // Har partner platform ke liye alag tracking parameters ho sakte hain
        if (product.affiliatePlatform === 'Amazon') {
          // Amazon Associates tag example
          urlObj.searchParams.set('tag', 'lynqar-21'); 
        } else {
          // Standard marketing tracking
          urlObj.searchParams.set('utm_source', 'lynqar');
          urlObj.searchParams.set('utm_medium', 'affiliate');
          urlObj.searchParams.set('utm_campaign', 'external_seller_engine');
        }
        finalUrl = urlObj.toString();
      } catch (e) {
        console.warn("URL format thoda ajeeb hai, direct link use kar rahe hain:", finalUrl);
      }
      
      // 4. Redirection (New Tab me open karna secure tareeke se)
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
    } else {
      console.error("Critical Error: Is affiliate product ka link missing hai!", product.id);
    }
  },

  /**
   * Merchant/Seller dashboard ke liye click stats taiyar karna.
   */
  getClickStats: (storeId: string) => {
    const clicks = storage.getAffiliateClicks(storeId);
    const products = storage.getProducts().filter(p => p.storeId === storeId);
    
    // Har product ke liye kitne clicks aaye, wo calculate ho raha hai
    const statsByProduct = products
      .filter(p => p.sellingModel === 'AFFILIATE')
      .map(p => ({
        productId: p.id,
        productName: p.name,
        clickCount: clicks.filter(c => c.productId === p.id).length
      }))
      .filter(s => s.clickCount > 0);

    return {
      totalClicks: clicks.length,
      byProduct: statsByProduct.sort((a, b) => b.clickCount - a.clickCount)
    };
  }
};